export default "__VITE_ASSET__e6441cd0__"